import React from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import AssetInputOrUploadSection from "./AssetInputOrUploadSection";
import { CREATIVE_ASSET_TYPES, CREATIVE_NAMES, IN_BANNER_VIDEO_AD_FIELDS } from "./definitions";
import InputTextSection from "./InputTextSection";
import VideoAssetCreativeType from "./VideoAssetCreativeType";
import BaseCreativeControls from "./BaseCreativeControls";
import { InputSwitch } from "primereact/inputswitch";
import { Button } from "primereact/button";

const CREATIVE_TYPE = CREATIVE_NAMES.IN_BANNER_VIDEO;
const SWITCH_SECTION_STYLES = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5em;
    padding: 6px;
    margin: 10px 0;
    background-color: #e6edf2;
    .label {
        font-weight: bold;
    }
`;

export default function InBannerVideo({
    displayCreativeUrl,
    collapsedCreaiveUrl,
    mobileCreativeUrl,
    videoCreativeUrl,
    handleChange,
    currentCustomer,
    topOffset,
    mobileTopOffset,
    impressionTag,
    clickTag,
    poster,
    vastUrl,
    vastDuration,
    videoCreativeType,
    adServingType,
    initialTopOffset,
    disallowCollapse
}) {
    return (
        <>
            <BaseCreativeControls
                adServingType={adServingType}
                changeHandler={handleChange}
                clickTag={clickTag}
                impressionTag={impressionTag}
                creativeType={CREATIVE_TYPE}
            >
                <div css={SWITCH_SECTION_STYLES}>
                    <div>
                        <Button
                            className="p-button-outlined p-button-icon-only p-button-info p-button-rounded"
                            icon="pi pi-info"
                            iconPos="right"
                            style={{ width: '20px', height: '20px' }}
                            tooltip={`When this option is enabled the creative will have a \"Collapse\" button available to dismiss the creative from view.`}
                        />
                        <span className="label">Is Collapsible By User?</span>
                    </div>
                    <InputSwitch
                        checked={!disallowCollapse}
                        name={IN_BANNER_VIDEO_AD_FIELDS.disallowCollapse}
                        onChange={e => {
                            handleChange(e, !e.value, CREATIVE_TYPE)
                        }}
                    />
                </div>
                <AssetInputOrUploadSection
                    inputValue={displayCreativeUrl}
                    inputLabel="Desktop Banner"
                    inputName={IN_BANNER_VIDEO_AD_FIELDS.displayCreativeUrl}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />
                {
                    !disallowCollapse && (
                        <AssetInputOrUploadSection
                            inputValue={collapsedCreaiveUrl}
                            inputLabel="Collapsed Desktop Banner"
                            inputName={IN_BANNER_VIDEO_AD_FIELDS.collapsedCreaiveUrl}
                            inputChangeHandler={handleChange}
                            inputAdtype={CREATIVE_TYPE}
                            isRequired={true}
                            currentCustomer={currentCustomer}
                            accept="image/*"
                            defaultExtension="jpeg"
                        />
                    )
                }
                <AssetInputOrUploadSection
                    inputValue={mobileCreativeUrl}
                    inputLabel="Mobile Banner"
                    inputName={IN_BANNER_VIDEO_AD_FIELDS.mobileCreativeUrl}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />
                <VideoAssetCreativeType
                    dropdownLabel="Video Creative Type"
                    types={CREATIVE_ASSET_TYPES}
                    videoCreativeTypePropertyName={IN_BANNER_VIDEO_AD_FIELDS.videoCreativeType}
                    videoCreativeType={videoCreativeType || 'video'}
                    handleChange={handleChange}
                    CREATIVE_TYPE={CREATIVE_TYPE}
                    currentCustomer={currentCustomer}
                    videoUrlInputLabel="Video URL"
                    videoUrlInputName={IN_BANNER_VIDEO_AD_FIELDS.videoCreativeUrl}
                    videoUrl={videoCreativeUrl}
                    vastUrl={vastUrl}
                    vastInputName={IN_BANNER_VIDEO_AD_FIELDS.vastUrl}
                    vastDurationInputName={IN_BANNER_VIDEO_AD_FIELDS.vastDuration}
                    vastDuration={vastDuration}
                />
                <AssetInputOrUploadSection
                    inputValue={poster}
                    inputLabel="Video poster"
                    inputName={IN_BANNER_VIDEO_AD_FIELDS.poster}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={false}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />
                <InputTextSection
                    label="Initial Top Offset (optional)"
                    name={IN_BANNER_VIDEO_AD_FIELDS.initialTopOffset}
                    value={initialTopOffset || 0}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    isNumericInput={true}
                    required={false}
                />
                <InputTextSection
                    label="Top Offset (optional)"
                    name={IN_BANNER_VIDEO_AD_FIELDS.topOffset}
                    value={topOffset || 0}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    isNumericInput={true}
                    required={false}
                />
                <InputTextSection
                    label="Mobile Top Offset (optional)"
                    name={IN_BANNER_VIDEO_AD_FIELDS.mobileTopOffset}
                    value={mobileTopOffset || 0}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    isNumericInput={true}
                    required={false}
                />
            </BaseCreativeControls>

        </>
    );
}